/* unplugin-vue-components disabled */import script from "./select-btns.vue?vue&type=script&lang=jsx"
export * from "./select-btns.vue?vue&type=script&lang=jsx"

import "./select-btns.vue?vue&type=style&index=0&id=37ba6fee&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ba6fee"]])

export default __exports__